// extracted by mini-css-extract-plugin
export var label = "_ac-1";
export var reminder = "_ac-0";